import { Component } from 'react';
import { connect } from "react-redux";
import "./ResponsiveFormSubmissions.css";

import { addSettings } from "../../../actions";
import {
  getClientFormWithSubmissions,
  viewGeneralSubmission,
  deleteSubmission,
  sendFormEmail,
  allClientRejections,
} from "./../../../config/forms_api_calls";
import $ from "jquery";
import { APP_LIVE_URL } from "../../../config/config";
import DataTableExtended from "../../../components/Tables/DataTableExtended";
import Tooltip from "@material-ui/core/Tooltip";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import Link from "@material-ui/core/Link";
import HomeIcon from "@material-ui/icons/Home";
import Typography from "@material-ui/core/Typography";
import FormRenderer from "../../../components/formRender";
import { TableLoader } from "../../../components/ContentLoaders/newLoaders/TableLoader";
import { FormLoader } from "../../../components/ContentLoaders/newLoaders/Form";
import MsaWarning from "../ExtraComponents/MsaWarning";
import SettingsError from "../ExtraComponents/SettingsError";
import PageTitle from "../ExtraComponents/PageTitle";
import HelperClass from "./../../../config/helperClass";
import dateFormat from "dateformat";

import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import MoreHorizIcon from "@material-ui/icons/MoreHoriz";

const auth = new HelperClass();

class FormSubmit extends Component {
  constructor() {
    super();

    this.state = {
      tableData: [],
      tableDataSingle: [],
      serviceData: [],
      tableLoaderListing: true,
      tableLoader: true,
      errorMessage: "",
      successMessage: "",
      showModal: false,
      modalContent: null,
      formAccNo: "",
      successMessageSaveResponse: "",
      errorMessageSaveResponse: "",
      form_accountno: "",
      form_token: "",
      formData: "",
      form_title: "",
      form_desc: "",
      totalSubmissions: [],
      activeTab: "total_submissions",
      assignedLoader: false,
      errorMessageTotals: "",
      errorMessageTotalsTitle: "",
      emailErrorMessage: "",
      emailErrorMessageTitle: "",
      emailSuccessMessage: "",
      total_completed: 0,
      total_not_completed: 0,
      submission_id: "",
      allow_multiple: 0,
      emailto: "",
      emailtoname: "",
      emailsubject: "",
      emailcontent: "",
      email_button: false,
      extra_files: [],
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      reject_general_button: false,
      reject_general_reason: "",

      allGeneralRejectionsListing: [],
      rejectionLoader: false,

      anchorEl: null,
      selectedRowId: null,
      selectedRowStatus: null,
      selectedRowData: null,
      menuType: null,

      generalColumnServices: [
        {
          name: "id",
          label: "Progress / ",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_client_title(value, tableMeta)}</div>;
            },
          },
        },
        {
          name: "submitter_name",
          label: "Submitted By",
        },
        {
          name: "is_submitted",
          label: "Submitted",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_submitted(value)}</div>;
            },
          },
        },
        {
          name: "submitted_on",
          label: "Submitted On",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return <div>{this.format_date(value)}</div>;
            },
          },
        },
        {
          name: "sent_by_email",
          label: "Sent By",
        },
        {
          name: "pdf_name",
          label: "View PDF",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>{this.format_download_general(value, tableMeta)}</div>
              );
            },
          },
        },
        {
          name: "submission_status",
          label: "Status",
          options: {
            customBodyRender: (value, tableMeta, updateValue) => {
              return (
                <div>{this.format_submission_status(value, tableMeta)}</div>
              );
            },
          },
        },

        {
          name: "id",
          label: "Actions",
          options: {
            customBodyRender: (value, tableMeta) => {
              const rowData = tableMeta.rowData;
              const isNotSubmitted = rowData[2] === 0;
              const isLinkOnly = rowData[10] === 1;
              const externalLink = rowData[11];

              return (
                <div className="d-flex align-items-center" style={{ gap: 6 }}>
                  {/* View Details */}
                  <Tooltip title="View Details" arrow>
                    <IconButton
                      size="small"
                      onClick={() => this.viewGeneralSubmission(value)}
                      style={{ padding: 0, backgroundColor: "transparent", outline: "none" }}
                    >
                      <em className="icon ni ni-card-view" style={{ fontSize: 20, color: "#09c2de" }}></em>
                    </IconButton>
                  </Tooltip>

                  {/* Submit Form OR Link Only */}
                  {isNotSubmitted && (
                    isLinkOnly ? (
                      <Tooltip title="Link Only" arrow>
                        <IconButton
                          size="small"
                          component="a"
                          href={externalLink}
                          target="_blank"
                          style={{ padding: 0, backgroundColor: "transparent", outline: "none" }}
                        >
                          <em className="icon ni ni-external" style={{ fontSize: 20, color: "#6576ff" }}></em>
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Tooltip title="Submit Form" arrow>
                        <IconButton
                          size="small"
                          onClick={() => {
                            const formAccNo = rowData[8] + "/" + rowData[9];
                            this.addMenuHistory("/" + auth.getResellerRegToken() + "/client/client_form_submit/" + formAccNo);
                          }}
                          style={{ padding: 0, backgroundColor: "transparent", outline: "none" }}
                        >
                          <em className="icon ni ni-edit" style={{ fontSize: 20, color: "#6576ff" }}></em>
                        </IconButton>
                      </Tooltip>
                    )
                  )}

                  {/* View Rejections */}
                  <Tooltip title="View Rejections" arrow>
                    <IconButton
                      size="small"
                      onClick={() => this.viewFormRejections(value, rowData)}
                      style={{ padding: 0, backgroundColor: "transparent", outline: "none" }}
                    >
                      <em className="icon ni ni-cross-circle" style={{ fontSize: 20, color: "#e85347" }}></em>
                    </IconButton>
                  </Tooltip>
                </div>
              );
            },
          },
        },
        {
          name: "form_accountno",
          options: {
            display: false,
          },
        },
        {
          name: "form_token",
          options: {
            display: false,
          },
        },
        {
          name: "link_form",
          options: {
            display: false,
          },
        },
        {
          name: "external_link",
          options: {
            display: false,
          },
        },
        {
          name: "progress",
          options: {
            display: false,
          },
        },
      ],
    };
  }

  handleMenuOpen = (event, rowId, status, rowData, menuType) => {
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: rowId,
      selectedRowStatus: status,
      selectedRowData: rowData,
      menuType: menuType,
    });
  };

  handleMenuClose = () => {
    this.setState({
      anchorEl: null,
      selectedRowId: null,
      selectedRowStatus: null,
      selectedRowData: null,
      menuType: null,
    });
  };

  async componentDidMount() {
    let form_accountno = this.props.props.match.params.form_accountno;
    let form_token = this.props.props.match.params.form_token;
    this.setState({
      formAccNo: form_accountno,
      form_token: form_token,
      form_accountno: form_accountno,
      assignedLoader: true,
    });
    const servicesResponce = await getClientFormWithSubmissions(
      auth.getClientAccount(),
      auth.getClientToken(),
      form_accountno,
      form_token
    );
    // console.log("getClientFormWithSubmissions: ", servicesResponce.data);

    if (
      servicesResponce.data.status === 403 ||
      servicesResponce.data.errors === "authentication missing" ||
      servicesResponce.data.errors === "jwt expired"
    ) {
      auth.clientLogout();
    } else if (servicesResponce.data.status === 404) {
      //window.location.replace("/error");
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        assignedLoader: false,
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
      });
    } else if (servicesResponce.data.status === 200) {
      this.setState({
        form_title: servicesResponce.data.form_title,
        totalSubmissions: servicesResponce.data.total_submissions,
        form_desc: servicesResponce.data.form_desc,
        total_completed: servicesResponce.data.total_completed,
        total_not_completed: servicesResponce.data.total_not_completed,
        allow_multiple: servicesResponce.data.data[0].allow_multiple,
        tableLoader: false,
        tableLoaderListing: false,
        assignedLoader: false,
      });
    } else {
      this.setState({
        tableLoader: false,
        tableLoaderListing: false,
        assignedLoader: false,
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
      });
      //window.location.replace("/error");
    }
    window.addEventListener("scroll", this.handleMenuClose);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleMenuClose);
  }

  format_submission_status = (value, tableMeta) => {
    const is_submitted = tableMeta.rowData[2];
    if (is_submitted === 1) {
      if (value === 0) {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-done"></em> Pending Approval
          </span>
        );
      } else if (value === 1) {
        return (
          <span className="badge badge-outline-success">
            <em className="icon ni ni-caution"></em> Approved
          </span>
        );
      } else if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else {
        return (
          <span className="badge badge-outline-primary">
            <em className="icon ni ni-caution"></em> Pending Approval
          </span>
        );
      }
    } else {
      if (value === 2) {
        return (
          <span className="badge badge-outline-danger">
            <em className="icon ni ni-caution"></em> Rejected
          </span>
        );
      } else {
        return "---";
      }
    }
  };

  format_client_title = (value, tableMeta) => {
    let progressPercentage = 0;

    if (tableMeta.rowData[12]) {
      let progress = tableMeta.rowData[12];
      let [completed, total] = progress.split("/").map(Number);
      progressPercentage = (completed / total) * 100;
    }
    return (
      <div className="progress-list gy-3">
        <div className="progress-wrap">
          <div className="progress-text">
            <div className="progress-label text-dark fs-10">
              {this.state.form_title}
            </div>
            <div className="progress-amount text-dark">
              {progressPercentage.toFixed(2)}%
            </div>
          </div>
          <div className="progress progress-md">
            <div
              className="progress-bar bg-teal"
              data-progress={progressPercentage}
              style={{
                width: `${progressPercentage}%`,
              }}
            ></div>
          </div>
        </div>
      </div>
    );
    //return this.state.form_title;
  };

  format_submitted = (value) => {
    if (value === 1) {
      return (
        <span className="badge badge-outline-success">
          <em className="icon ni ni-done"></em> Yes
        </span>
      );
    } else {
      return (
        <span className="badge badge-outline-light">
          <em className="icon ni ni-caution"></em> No
        </span>
      );
    }
  };

  format_download_general = (value, tableMeta) => {
    // console.log("format_download value: ", value);
    let form_token = tableMeta.rowData[9];
    if (value && value !== "") {
      return (
        <>
          <a
            onClick={() => this.downloadPdf(value)}
            title="Download PDF"
            style={{
              cursor: "pointer",
            }}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-download"></em>
            </span>
          </a>
          <a
            onClick={() =>
              this.addMenuHistory(
                "/" +
                auth.getResellerRegToken() +
                "/client/client_form_submission_single/" +
                form_token
              )
            }
            title="Submission View"
            style={{
              cursor: "pointer",
              marginLeft: "5px",
            }}
          >
            <span className="badge badge-outline-primary">
              <em className="icon ni ni-table-view"></em>
            </span>
          </a>
        </>
      );
    } else {
      return <span className="badge badge-outline-light">---</span>;
    }
  };

  changeActiveTab = (tab) => {
    this.setState({
      activeTab: tab,
      //assignedLoader: true,
    });
  };

  format_date = (value, tableMeta) => {
    let date = value;
    if (date && date !== "") {
      //return dateFormat(date, "mmmm dS, yyyy, h:MM:ss TT");
      return dateFormat(date, "mm-dd-yyyy");
    }
    return "---";
  };

  handleChange = async (event) => {
    const { target } = event;
    const value = target.type === "checkbox" ? target.checked : target.value;
    const { name } = target;

    this.setState({
      [name]: value,
    });
  };

  closeModal = () => {
    this.setState({ modalContent: null, formAccNo: "" }, () => {
      window.$("#modalPreviewForm").modal("hide");
    });
  };

  handleSubmitForm = (formData) => {
    let response = JSON.stringify(formData);
    this.saveResponse(response, this.state.formAccNo);
  };

  viewGeneralSubmission = async (id) => {
    const { form_accountno } = this.state;
    this.setState({ viewLoader: true, extra_files: [] });
    const servicesResponse = await viewGeneralSubmission(
      auth.getClientAccount(),
      auth.getClientToken(),
      form_accountno,
      id
    );
    window.$("#modalViewGeneralSubmission").modal("show");
    // console.log("getTotalSubmissions.data.data: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageTotalsTitle: "No Submission",
        errorMessageTotals: "There are no submissions right now.",
        viewLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      let extra_files = [];
      if (servicesResponse.data.data && servicesResponse.data.data.length > 0) {
        if (servicesResponse.data.data[0].extra_files) {
          extra_files = JSON.parse(servicesResponse.data.data[0].extra_files);
        }
      }
      this.setState({
        viewGeneralSubmission: servicesResponse.data.data,
        extra_files: extra_files,
        viewLoader: false,
      });

      //
    }
  };

  viewFormRejections = async (id, tableMeta) => {
    const { form_accountno, form_title } = this.state;
    this.setState({
      rejectGeneralErrorMessage: "",
      rejectGeneralSuccessMessage: "",
      allGeneralRejectionsListing: [],
      rejectionLoader: true,
    });
    window.$("#modalRejectionGeneral").modal("show");
    const servicesResponse = await allClientRejections(
      auth.getClientAccount(),
      auth.getClientToken(),
      form_accountno,
      id
    );

    // console.log("allGeneralRejections: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage: "Submission not found.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "rejection_not_found"
    ) {
      this.setState({
        approveGeneralErrorMessage:
          "There are no rejections against this submission.",
        approveGeneralSuccessMessage: "",
        rejectionLoader: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState({
        approveGeneralErrorMessage: "",
        approveGeneralSuccessMessage: "",

        allGeneralRejectionsListing: servicesResponse.data.data,
        rejectionLoader: false,
      });
    } else {
      this.setState({
        rejectionLoader: false,
        approveGeneralErrorMessage:
          "There is some error while getting the rejections.",
        approveGeneralSuccessMessage: "",
      });
    }
  };

  deleteGeneralModal = async (id) => {
    this.setState({ submission_id: id });
    window.$("#modalDeleteGeneralAlert").modal("show");
  };

  modalHideDelGeneral = async () => {
    this.setState({ submission_id: "" });
    window.$("#modalDeleteGeneralAlert").modal("hide");
  };

  deleteGeneralSubmission = async (id) => {
    const { form_accountno, submission_id } = this.state;
    this.setState({ viewLoader: true });
    const servicesResponse = await deleteSubmission(
      auth.getClientAccount(),
      auth.getClientToken(),
      form_accountno,
      submission_id
    );

    // console.log("getTotalSubmissions.data.data: ", servicesResponse.data);

    if (
      servicesResponse.data.status === 403 ||
      servicesResponse.data.errors === "authentication missing" ||
      servicesResponse.data.errors === "jwt expired"
    ) {
      auth.logout();
    } else if (
      servicesResponse.data.status === 404 &&
      servicesResponse.data.message === "form_not_found"
    ) {
      this.setState({
        errorMessageDelete: "There are no submissions right now.",
        isProcessing: false,
      });
    } else if (
      servicesResponse.data.status === 200 &&
      servicesResponse.data.message === "success"
    ) {
      this.setState(
        {
          successMessageDelte: "Submission deleted successfully.",
          isProcessing: false,
        },
        () => {
          setTimeout(() => {
            this.getTotalSubmissions();
            window.$("#modalDeleteGeneralAlert").modal("hide");
            this.setState({ successMessage: "" });
            //window.location.reload();
          }, 3000);
        }
      );
    } else {
      this.setState({
        errorMessageDelete: "Error failed to delete submission.",
        isProcessing: false,
      });
    }
  };

  addMenuHistory = (link) => {
    this.props.props.history.push(link);
  };

  downloadPdf = async (d_f_name) => {
    //var url = d_f_name;
    if (d_f_name && d_f_name !== "") {
      let file_name = d_f_name;
      var url = APP_LIVE_URL + "files_data/form_response_uploads/" + d_f_name;
      fetch(url)
        .then((x) => x.blob())
        .then((b) => {
          // console.log("B INSTANCE", b instanceof Blob);
          const url = window.URL.createObjectURL(b);
          var a = document.createElement("a");
          document.body.appendChild(a);
          a.style = "display: none";
          a.href = url;
          a.download = file_name;
          a.click();
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          this.setState({
            errorMessage:
              "There is some error while downloading the attachment.",
          });
          setTimeout(() => {
            this.setState({ errorMessage: "" });
          }, 4000);
          // Handle any errors that occurred during the fetch
          console.error("Fetch error:", error);
        });
    } else {
      this.setState({
        errorMessage: "Attachement not found.",
      });
      setTimeout(() => {
        this.setState({ errorMessage: "" });
      }, 4000);
    }
  };

  validateEmailAdd = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isValidEmail = emailRegex.test(email);
    //console.log("isValidEmail: " + " " + email + " = " + isValidEmail);
    if (isValidEmail) {
      return true;
    }
    return false;
  };

  fieldValidation = () => {
    let { emailtoname, emailto, emailsubject, emailcontent } = this.state;

    if (emailtoname === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Name is required.",
      });
      return false;
    } else if (emailto === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "To email address is required.",
      });
      return false;
    } else if (this.validateEmailAdd(emailto) === false) {
      this.setState({
        emailErrorMessageTitle: "Invalid Format",
        emailErrorMessage: "Invalid email address format.",
      });
      return false;
    } else if (emailsubject === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Subject is required.",
      });
      return false;
    } else if (emailcontent === "") {
      this.setState({
        emailErrorMessageTitle: "Missing Fields",
        emailErrorMessage: "Custom content is required.",
      });
      return false;
    } else {
      this.setState({
        emailErrorMessageTitle: "",
        emailErrorMessage: "",
      });
    }
    return true;
  };

  submitFormEmail = async () => {
    const { form_accountno, emailtoname, emailto, emailsubject, emailcontent } =
      this.state;

    if (this.fieldValidation() === true) {
      this.setState({
        email_button: true,
        emailErrorMessage: "",
        emailErrorMessageTitle: "",
        emailSuccessMessage: "",
      });
      const servicesResponce = await sendFormEmail(
        auth.getClientAccount(),
        auth.getClientToken(),
        form_accountno,
        emailtoname,
        emailto,
        emailsubject,
        emailcontent
      );
      // console.log("submitOrderEmail: ", servicesResponce.data);

      if (
        servicesResponce.data.status === 403 ||
        servicesResponce.data.errors === "authentication missing" ||
        servicesResponce.data.errors === "jwt expired"
      ) {
        auth.logout();
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "already_sent"
      ) {
        this.setState({
          emailErrorMessageTitle: "Already Sent",
          emailErrorMessage:
            "This form has already been sent to the email and is still not submitted.",
          email_button: false,
        });
      } else if (
        servicesResponce.data.status === 404 &&
        servicesResponce.data.message === "insert_error"
      ) {
        this.setState({
          emailErrorMessageTitle: "System Error",
          emailErrorMessage: "This is some error while sending the form.",
          email_button: false,
        });
      } else if (
        servicesResponce.data.status === 200 &&
        servicesResponce.data.message === "success"
      ) {
        this.setState({
          emailSuccessMessage: "Email sent successfully.",
          payment_status: servicesResponce.data.data,
          emailErrorMessageTitle: "",
          emailErrorMessage: "",
          emailsubject: "",
          emailto: "",
          emailtoname: "",
          emailcontent: "",
          email_button: false,
        });
      } else {
        this.setState({
          emailErrorMessageTitle: "System Error",
          emailErrorMessage:
            "There is some error while processing your request.",
          email_button: false,
        });
      }
    }

    setTimeout(() => {
      this.setState({
        emailErrorMessage: "",
        emailSuccessMessage: "",
      });
    }, 4000);
  };

  render() {
    const { step } = this.state;
    const { email, VerifyUsernameButton } = this.state;
    const values = {
      email,
      VerifyUsernameButton,
    };
    //$(".nk-block .MUIDataTable-paper-2").css("padding", "10px");
    return (
      <div className="nk-content forms-submissions-page">
        <div className="container-fluid">
          {this.props.is_msa_signed === "No" &&
            this.props.from !== "dashboard" ? (
            <MsaWarning />
          ) : null}
          <div className="nk-content-inner">
            <div className="nk-content-body">
              <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between g-3">
                  <div className="nk-block-head-content">
                    <h3 className="nk-block-title page-title">
                      <a
                        onClick={() =>
                          this.addMenuHistory(
                            "/" + auth.getResellerRegToken() + "/client/forms"
                          )
                        }
                        style={{ cursor: "pointer" }}
                      >
                        Forms
                      </a>{" "}
                      /{" "}
                      <strong className="text-primary small">
                        {this.state.form_title}
                      </strong>
                    </h3>
                    <div className="nk-block-des text-soft">
                      <ul className="list-inline">
                        <li>
                          Form ID:{" "}
                          <span className="text-base">
                            {this.state.form_accountno}
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="nk-block-head-content">
                    <a
                      onClick={() =>
                        this.addMenuHistory(
                          "/" + auth.getResellerRegToken() + "/client/forms"
                        )
                      }
                      //href="#"
                      className="btn btn-outline-light bg-white d-none d-sm-inline-flex"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                      <span>Back</span>
                    </a>
                    <a
                      onClick={() =>
                        this.addMenuHistory(
                          "/" + auth.getResellerRegToken() + "/client/forms"
                        )
                      }
                      //href="#"
                      className="btn btn-icon btn-outline-light bg-white d-inline-flex d-sm-none"
                    >
                      <em className="icon ni ni-arrow-left"></em>
                    </a>
                  </div>
                </div>
              </div>
              <div className="nk-block">
                <div className="card card-bordered">
                  <div className="card-aside-wrap forms-submissions-layout">
                    <div className="card-content forms-submissions-main-content">
                      <ul className="nav nav-tabs nav-tabs-mb-icon nav-tabs-card">
                        <li className="nav-item">
                          <a
                            className={`nav-link ${this.state.activeTab === "total_submissions"
                              ? "active"
                              : ""
                              }`}
                            onClick={(e) => {
                              this.changeActiveTab("total_submissions");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-file-text"></em>
                            <span>Form Submissions</span>
                          </a>
                        </li>

                        <li className="nav-item">
                          <a
                            className={`nav-link ${this.state.activeTab === "email_form"
                              ? "active"
                              : ""
                              }`}
                            onClick={(e) => {
                              this.changeActiveTab("email_form");
                            }}
                            style={{ cursor: "pointer" }}
                          >
                            <em className="icon ni ni-mail"></em>
                            <span>Email Form</span>
                          </a>
                        </li>
                        {/*<li className="nav-item nav-item-trigger d-xxl-none">
                                                        <a className="toggle btn btn-icon btn-trigger" dataTarget="userAside"><em className="icon ni ni-user-list-fill"></em></a>
                                                    </li>*/}
                      </ul>
                      <div className="tab-content">
                        <div
                          className={
                            this.state.activeTab === "email_form"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="email_forms"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              {(this.state.allow_multiple === 0 &&
                                this.state.total_completed === 0) ||
                                this.state.allow_multiple === 1 ? (
                                <div className="row g-gs">
                                  <div className="col-sm-12">
                                    <h5>Send Form</h5>
                                    {this.state.emailErrorMessage !== "" ? (
                                      <div className="alert alert-pro alert-danger">
                                        <div className="alert-text">
                                          <h6>
                                            {this.state.emailErrorMessageTitle}
                                          </h6>
                                          <p>{this.state.emailErrorMessage}</p>
                                        </div>
                                      </div>
                                    ) : null}
                                    {this.state.emailSuccessMessage !== "" ? (
                                      <div className="alert alert-pro alert-success">
                                        <div className="alert-text">
                                          <h6>Success</h6>
                                          <p>
                                            {this.state.emailSuccessMessage}
                                          </p>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group mt-2">
                                      <label className="form-label" htmlFor="emailto">
                                        To Name <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailtoname"
                                          name="emailtoname"
                                          value={this.state.emailtoname}
                                          onChange={this.handleChange}
                                          placeholder="Enter the full name"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-6">
                                    <div className="form-group mt-2">
                                      <label className="form-label" htmlFor="emailto">
                                        To <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailto"
                                          name="emailto"
                                          value={this.state.emailto}
                                          onChange={this.handleChange}
                                          placeholder="Enter email address"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 mt-2">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        htmlFor="emailsubject"
                                      >
                                        Subject <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <input
                                          type="text"
                                          className="form-control form-control-lg"
                                          id="emailsubject"
                                          name="emailsubject"
                                          value={this.state.emailsubject}
                                          onChange={this.handleChange}
                                          placeholder="Email Subject"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 mt-2">
                                    <div className="form-group">
                                      <label
                                        className="form-label"
                                        htmlFor="emailcontent"
                                      >
                                        Custom Message <sup>*</sup>
                                      </label>
                                      <div className="form-control-wrap">
                                        <textarea
                                          className="form-control"
                                          id="emailcontent"
                                          name="emailcontent"
                                          value={this.state.emailcontent}
                                          onChange={this.handleChange}
                                        ></textarea>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-sm-12 mt-2 d-flex justify-content-end">
                                    <div className="nk-block-head-content">
                                      <ul className="nk-block-tools gx-3">
                                        {this.state.email_button === true ? (
                                          <button
                                            className="btn btn-primary"
                                            type="button"
                                            disabled
                                          >
                                            <span
                                              className="spinner-grow spinner-grow-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                            <span> Processing... </span>
                                          </button>
                                        ) : (
                                          <li>
                                            <a
                                              onClick={() =>
                                                this.submitFormEmail()
                                              }
                                              style={{
                                                cursor: "pointer",
                                                color: "#fff",
                                              }}
                                              className="btn btn-primary"
                                            >
                                              <em className="icon ni ni-check-round-cut"></em>{" "}
                                              <span>Send Email</span>{" "}
                                            </a>
                                          </li>
                                        )}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              ) : (
                                <div className="row g-gs">
                                  <div className="col-sm-12">
                                    <div className="alert alert-pro alert-primary">
                                      <div className="alert-text">
                                        <h6>Form Submission Limit</h6>
                                        <p>
                                          You cannot send this form because it
                                          has already been submitted. Multiple
                                          submissions are not allowed.{" "}
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                        {/* EMAIL FORM */}
                        <div
                          className={
                            this.state.activeTab === "total_submissions"
                              ? "tab-pane active"
                              : "tab-pane"
                          }
                          id="tabItemAgreements"
                        >
                          <div className="card-inner">
                            <div className="nk-block">
                              <div className="nk-block-head">
                                <h5 className="title mb-4">Forms Submissions</h5>

                                {this.state.assignedLoader === true ? (
                                  FormLoader()
                                ) : (
                                  <>
                                    <div
                                      className="tab-pane active"
                                      id="tabItemSigned"
                                    >
                                      {this.state.errorMessageTotals !== "" ? (
                                        <div className="example-alert example-alert-revoke">
                                          <div className="alert alert-pro alert-danger">
                                            <div className="alert-text">
                                              <h4>
                                                {
                                                  this.state
                                                    .errorMessageTotalsTitle
                                                }
                                              </h4>
                                              <p>
                                                {this.state.errorMessageTotals}
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : null}
                                      <div className="card card-bordered card-preview">
                                        <DataTableExtended
                                          columns={
                                            this.state.generalColumnServices
                                          }
                                          tableData={
                                            this.state.totalSubmissions
                                          }
                                          title=""
                                        />
                                      </div>
                                  </div>
                              </>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* EMAIL FORM */}
                      <div className="nk-divider divider md"></div>
                    </div>
                  </div>
                  <div
                    className="card-aside card-aside-right user-aside forms-submissions-aside"
                    data-content="userAside"
                    data-toggle-screen="xxl"
                    data-toggle-overlay="true"
                    data-toggle-body="true"
                  >
                    <div className="card-inner-group" data-simplebar>
                      <div className="card-inner">
                        <div className="user-card user-card-s2">
                          <div className="user-info">
                            {/*{this.state.form_status &&
                              this.state.form_status === 1 ? (
                                <div className="badge badge-outline-success badge-pill ucap">
                                  Active
                                </div>
                              ) : (
                                <div className="badge badge-outline-light badge-pill ucap">
                                  Inactive
                                </div>
                              )}*/}

                            <h5>{this.state.form_title}</h5>
                            <span className="sub-text"></span>
                          </div>
                        </div>
                      </div>

                      <div className="card-inner text-center">
                        <h6 className="overline-title-alt mb-2">Totals</h6>
                        <div className="row">
                          <div className="col-6">
                            <div className="profile-stats">
                              <span className="amount">
                                {this.state.total_completed}
                              </span>
                              <span className="sub-text">Submitted</span>
                            </div>
                          </div>
                          <div className="col-6">
                            <div className="profile-stats">
                              <span className="amount">
                                {this.state.total_not_completed}
                              </span>
                              <span className="sub-text">Not Submitted</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/*<div className="card-inner">
                          <h6 className="overline-title-alt mb-2">Additional</h6>
                          <div className="row g-3">
                            <div className="col-6">
                              <span className="sub-text">User ID:</span>
                              <span>UD003054</span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">Last Login:</span>
                              <span>15 Feb, 2019 01:02 PM</span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">KYC Status:</span>
                              <span className="lead-text text-success">
                                Approved
                              </span>
                            </div>
                            <div className="col-6">
                              <span className="sub-text">Register At:</span>
                              <span>Nov 24, 2019</span>
                            </div>
                          </div>
                        </div>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* View General Submissions */}
            <div
              className="modal fade zoom"
              tabIndex="-1"
              id="modalViewGeneralSubmission"
            >
              <div
                className="modal-dialog modal-xl modal-dialog-top"
                role="document"
              >
                <div className="modal-content">
                  <div className="modal-header">
                    <div
                      className="modal-title"
                      style={{ textAlign: "center", fontSize: "20px" }}
                    >
                      <strong>
                        <em className="icon ni ni-list-round"></em> Submission
                        Details{" "}
                      </strong>
                    </div>
                    <a
                      href="#"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <em className="icon ni ni-cross"></em>
                    </a>
                  </div>

                  <div className="modal-body">
                    {/* NRC DIVS START */}

                    {this.state.viewLoader === true ? (
                      FormLoader()
                    ) : (
                      <>
                        <div>
                          <div className="card card-bordered">
                            <div className="card-inner-group">
                              {this.state.viewGeneralSubmission &&
                                this.state.viewGeneralSubmission.length > 0 ? (
                                <div className="card-inner">
                                  <div className="sp-plan-head">
                                    <h6 className="title">
                                      Form Submission Details
                                    </h6>
                                  </div>
                                  <div className="sp-plan-desc sp-plan-desc-mb">
                                    <table className="table table-bordered table-striped">
                                      {this.state.viewGeneralSubmission.map(
                                        (general, index) => (
                                          <tbody
                                            key={index}
                                            className="text-dark"
                                          >
                                            <tr>
                                              <td>Sent To Name</td>
                                              <td>
                                                {general.submitter_name}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Sent To Email</td>
                                              <td>
                                                {general.submitter_email}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Sent By</td>
                                              <td>
                                                {general.sent_by_email &&
                                                  general.sent_by_email !== ""
                                                  ? general.sent_by_email
                                                  : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Sent Date</td>
                                              <td>
                                                {this.format_date(
                                                  general.sent_on
                                                )}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Submitted</td>
                                              <td>
                                                {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                  <span className="badge badge-dot badge-success">
                                                    Yes
                                                  </span>
                                                ) : (
                                                  <span className="badge badge-dot badge-danger">
                                                    No
                                                  </span>
                                                )}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Submission Date</td>
                                              <td>
                                                {general.is_submitted &&
                                                  general.is_submitted === 1
                                                  ? this.format_date(
                                                    general.submitted_on
                                                  )
                                                  : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>View PDF</td>
                                              <td>
                                                {general.is_submitted &&
                                                  general.is_submitted === 1 ? (
                                                  <a
                                                    style={{
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      this.downloadPdf(
                                                        general.pdf_name
                                                      )
                                                    }
                                                  >
                                                    <span className="badge badge-outline-dark">
                                                      View
                                                    </span>
                                                  </a>
                                                ) : (
                                                  "---"
                                                )}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Extra Files</td>
                                              <td>
                                                {this.state.extra_files &&
                                                  this.state.extra_files
                                                    .length > 0 ? (
                                                  <>
                                                    {this.state.extra_files.map(
                                                      (file, index) => (
                                                        <>
                                                          {file.file_name &&
                                                            file.file_name !==
                                                            "" ? (
                                                            <div
                                                              key={index}
                                                              className="col-md-12"
                                                              style={{
                                                                paddingLeft:
                                                                  "0px",
                                                              }}
                                                            >
                                                              {file.field_name.trim()}{" "}
                                                              <span
                                                                onClick={() =>
                                                                  this.downloadPdf(
                                                                    file.file_name
                                                                  )
                                                                }
                                                                className="badge badge-outline-primary"
                                                                style={{
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                title="Download / View"
                                                              >
                                                                <em className="icon ni ni-download"></em>{" "}
                                                                {file.file_name.trim()}
                                                              </span>
                                                            </div>
                                                          ) : null}
                                                        </>
                                                      )
                                                    )}
                                                  </>
                                                ) : (
                                                  "---"
                                                )}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Sent Form Subject</td>
                                              <td>
                                                {general.email_subject &&
                                                  general.email_subject !== ""
                                                  ? general.email_subject
                                                  : "---"}
                                              </td>
                                            </tr>
                                            <tr>
                                              <td>Sent Form Message</td>
                                              <td>
                                                {general.email_content &&
                                                  general.email_content !== ""
                                                  ? general.email_content
                                                  : "---"}
                                              </td>
                                            </tr>
                                          </tbody>
                                        )
                                      )}
                                    </table>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
            {/* View General Submissions */}
            {/* START DELETE MODAL  */}
            <div
              className="modal fade"
              tabIndex="-1"
              id="modalDeleteGeneralAlert"
            >
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <a
                    style={{ cursor: "pointer" }}
                    className="close"
                    onClick={() => {
                      this.modalHideDel();
                    }}
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-body modal-body-lg text-center">
                    <div className="nk-modal">
                      <em className="nk-modal-icon icon icon-circle icon-circle-xxl ni ni-trash bg-success"></em>

                      <h4 className="nk-modal-title">Delete Submission?</h4>

                      <div className="nk-modal-text">
                        {this.state.errorMessageDelete !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-danger">
                              <div className="alert-text">
                                <h4>Error</h4>
                                <p>{this.state.errorMessageDelete}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {this.state.successMessageDelte !== "" ? (
                          <div
                            className="example-alert"
                            style={{ marginBottom: "15px" }}
                          >
                            <div className="alert alert-pro alert-success">
                              <div className="alert-text">
                                <h4>Success</h4>
                                <p>{this.state.successMessageDelte}</p>
                              </div>
                            </div>
                          </div>
                        ) : null}

                        <div className="caption-text">
                          Are you sure you want to delete this submission
                        </div>
                      </div>
                      <div className="nk-modal-action">
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-primary"
                          onClick={() => {
                            this.modalHideDelGeneral();
                          }}
                        >
                          CANCEL
                        </a>
                        {"  "}
                        <a
                          style={{ cursor: "pointer" }}
                          className="btn btn-lg btn-mw btn-danger"
                          onClick={() => {
                            this.deleteGeneralSubmission();
                          }}
                          disabled={
                            this.state.disabled || this.state.isProcessing
                          } // disable button when processing
                        >
                          {this.state.isProcessing ? (
                            <span>DELETING...</span>
                          ) : (
                            <span>DELETE</span>
                          )}
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END DELETE MODAL  */}
            {/* START REJECTIONS MODAL */}
            <div className="modal fade" tabIndex="-1" id="modalRejectionGeneral">
              <div
                className="modal-dialog modal-dialog-top modal-xl"
                role="document"
              >
                <div className="modal-content">
                  <a
                    href="#"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <em className="icon ni ni-cross"></em>
                  </a>
                  <div className="modal-header">
                    <h5 className="modal-title">
                      All rejections{" "} <small className='text-muted'>- {this.state.form_title}</small>
                    </h5>
                  </div>
                  <div className="modal-body">
                    {this.state.rejectGeneralErrorMessage !== "" ? (
                      <div className="alert alert-pro alert-danger mb-2">
                        <div className="alert-text">
                          <h6>Error</h6>
                          <p>{this.state.rejectGeneralErrorMessage} </p>
                        </div>
                      </div>
                    ) : null}
                    {this.state.rejectGeneralSuccessMessage !== "" ? (
                      <div className="alert alert-pro alert-success mb-2">
                        <div className="alert-text">
                          <h6>Success</h6>
                          <p>{this.state.rejectGeneralSuccessMessage} </p>
                        </div>
                      </div>
                    ) : null}
                    <div id="revokeReasonItems">
                      {this.state.rejectionLoader === true ? (
                        FormLoader()
                      ) : (
                        <>
                          <div>
                            <div className="card card-bordered">
                              <div className="card-inner-group">
                                {this.state.allGeneralRejectionsListing &&
                                  this.state.allGeneralRejectionsListing
                                    .length > 0 ? (
                                  <div className="card-inner">
                                    <div className="sp-plan-head">
                                      <h6 className="title">
                                        All Rejections{" "} <small className='text-muted'>- {this.state.form_title}</small>
                                      </h6>
                                    </div>
                                    <div className="sp-plan-desc sp-plan-desc-mb">
                                      <table className="table table-bordered table-striped">
                                        <thead>
                                          <th>Form Title</th>
                                          <th>Rejection date</th>
                                          <th>Reason</th>
                                          <th>Submitted PDF</th>
                                        </thead>
                                        {this.state.allGeneralRejectionsListing.map(
                                          (general, index) => (
                                            <tbody
                                              key={`ind${index}`}
                                              className="text-dark"
                                            >
                                              <tr>
                                                <td>
                                                  {this.state.form_title}
                                                </td>
                                                <td>
                                                  {this.format_date(
                                                    general.rejection_date
                                                  )}
                                                </td>
                                                <td>
                                                  {general.rejection_reason}
                                                </td>
                                                <td>
                                                  {general.is_submitted &&
                                                    general.is_submitted ===
                                                    1 ? (
                                                    <a
                                                      style={{
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        this.downloadPdf(
                                                          general.pdf_name
                                                        )
                                                      }
                                                    >
                                                      <span className="badge badge-outline-dark">
                                                        View
                                                      </span>
                                                    </a>
                                                  ) : (
                                                    "---"
                                                  )}
                                                </td>
                                              </tr>
                                            </tbody>
                                          )
                                        )}
                                      </table>
                                    </div>
                                  </div>
                                ) : (
                                  <div className="alert alert-pro alert-primary">
                                    <div className="alert-text">
                                      <h6>No Rejection</h6>
                                      <p>
                                        Rejections are not available against
                                        this submission.
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* END REJECTIONS MODAL */}
          </div>
        </div>
      </div>
      </div >
    );
  }
}

const mapStateToProps = (state) => {
  return {
    defaultSettings: state.settings,
    is_msa_signed: state.is_msa_signed,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    addSettings: (payload) => dispatch(addSettings(payload)),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(FormSubmit);
